// Search here. https://remixicon.com/

export const icons = {
    "tcm-add": "ri-add-line",
    "tcm-admin": "ri-settings-line",
    "tcm-ai": "ri-bard-line",
    "tcm-category": "ri-booklet-line",
    "tcm-configuration": "ri-settings-4-line",
    "tcm-clear": "ri-delete-bin-3-line",
    "tcm-clear-selection": "ri-checkbox-blank-line",
   
    "tcm-documents": "ri-article-line",
    "tcm-drag-handle": "ri-draggable",
    "tcm-edit": "ri-pencil-line",
    "tcm-etender": "ri-coin-line",
    "tcm-etender-profile": "ri-account-circle-line",
    "tcm-fields": "ri-grid-line",
    "tcm-file": "ri-file-text-line",
    "tcm-grid": "ri-table-line",
    "tcm-history": "ri-history-line",
    "tcm-home": "ri-home-3-line",
    "tcm-info": "ri-information-line",
    "tcm-invalid": "ri-close-circle-line",
    "tcm-item-home": "ri-edit-box-line", // "ri-home-office-line",
    "tcm-item-goals": "ri-focus-3-line",
    "tcm-item-select": "ri-arrow-right-line",
    "tcm-items": "ri-file-list-3-line",
    "tcm-items-list": "ri-list-view",
    "tcm-item-unselect": "ri-arrow-left-line",
    "tcm-line-edit": "ri-hammer-line",
    "tcm-mapping": "ri-expand-width-line",
    "tcm-manual-goal": "ri-wrench-line",
    "tcm-master-group": "ri-government-line",
    "tcm-master-id": "ri-key-line",
    "tcm-master-group-field": "ri-square-line",
    "tcm-master-number": "ri-hashtag",
    "tcm-move-left": "ri-arrow-left-fill",
    "tcm-move-right": "ri-arrow-right-fill",
    "tcm-menu": "ri-more-2-fill",
    "tcm-not-set": "ri-circle-line",
    "tcm-preview": "ri-eye-line",
    "tcm-product": "ri-file-line",
    "tcm-rankings": "ri-sort-desc",
    "tcm-rejection-reason": "ri-close-circle-line",
    "tcm-reports": "ri-article-line",
    "tcm-response": "ri-file-download-line",
    "tcm-response-details": "ri-file-text-line",
    "tcm-response-id": "ri-hashtag",
    "tcm-response-number": "ri-info-card-line",
    "tcm-response-status": "ri-file-shield-2-line",
    "tcm-response-upload": "ri-contacts-book-upload-line",
    "tcm-responses": "ri-folder-download-line",
    "tcm-rules": "ri-functions",
    "tcm-save": "ri-check-line",
    "tcm-search": "ri-search-line",
    "tcm-select-all": "ri-checkbox-multiple-line",
    "tcm-schedule": "ri-award-line",
    "tcm-schedules": "ri-award-fill",
    "tcm-schedule-status": "ri-shield-line",
    "tcm-specific-goals": "ri-target-line",
    "tcm-status": "ri-checkbox-circle-line",
    "tcm-status-busy": "ri-loader-line",
    "tcm-status-completed": "ri-checkbox-circle-line",
    "tcm-status-error": "ri-error-warning-line",
    "tcm-status-failed": "ri-error-warning-line",
    "tcm-status-waiting": "ri-hourglass-2-line",
    "tcm-supplier": "ri-building-3-line",
    "tcm-supplier-reg": "ri-profile-line",
    "tcm-supplier-rules": "ri-file-check-line",
    "tcm-suppliers": "ri-building-3-line",
    "tcm-system-field": "ri-star-s-fill",
    "tcm-system-goal": "ri-server-line",
    "tcm-template": "ri-file-excel-2-line",
    "tcm-trash": "ri-delete-bin-line",
    "tcm-type-manual": "ri-booklet-line",
    "tcm-type-system": "ri-computer-line",
    "tcm-validate": "ri-verified-badge-line",
    "tcm-validate-row": "ri-shield-check-line",
    "tcm-valid": "ri-checkbox-circle-line"
}


